import { useEffect } from 'react';
import type { FunctionComponent } from 'react';

import { ACCESS_LEVEL_TO_PLAN } from '../../../../shared/subscriptions';
import { window } from '../../../globals';
import utils from '../../../utils';
import type { FossaFeature } from '../../settings/billing/features/consts';

import InvalidAccess from './InvalidAccess';

type Props = {
  className?: string;
  focusFeature?: FossaFeature;
  // Defaults to 'premium'.
  level?: keyof typeof ACCESS_LEVEL_TO_PLAN;
  children?: any;
  show?: boolean;
  // Defaults to 'showInline'.
  behavior?: 'showInline' | 'showModal' | 'hide' | 'showPage';
  verify?: () => boolean;
  onHide?: () => void;
};

/**
 * Component used for restricting access to a feature or page.
 */
const AccessGate: FunctionComponent<Props> = ({
  className,
  focusFeature,
  level = 'premium',
  children,
  show,
  behavior = 'showInline',
  verify,
  onHide,
}) => {
  //  Show the plan selector modal when show changes
  useEffect(() => {
    if (show && behavior === 'showModal' && !utils.verify_subscription(level)) {
      window.showPlanSelectorModal({
        tier: ACCESS_LEVEL_TO_PLAN[level],
        onHide,
        focusFeature,
      });
    }
  }, [show, level, behavior, focusFeature, onHide]);

  const hasAccess = verify ? verify() === true : utils.verify_subscription(level);
  if (!hasAccess) {
    if (behavior === 'showModal' || behavior === 'hide') {
      return null;
    }

    return (
      <div className={className}>
        <InvalidAccess
          focusFeature={focusFeature}
          accessLevel={level}
          isFullPage={behavior === 'showPage'}
        />
      </div>
    );
  }

  return children;
};

export default AccessGate;
